export default __webpack_public_path__ + "static/media/pt_BR.1e932ab9.svg";